<div class="container d-flex flex-column flex-fill align-self-stretch">
    <div class="row justify-content-center flex-fill d-flex align-self-stretch px-sm-0">
        <mat-card class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 rounded-0 mat-elevation-z13 d-flex flex-column align-self-stretch">
            <router-outlet></router-outlet>
        </mat-card>
    </div>
</div>
